export default __webpack_public_path__ + "static/media/post-08-detail.cc69e78f.jpg";